import type { SetStateAction } from 'react'
import { useState } from 'react'

import {
  Button,
  FormattedMessage,
  Tooltip,
  showSnackbar,
} from '@b-stock/fe-core/bstock-react'

import type { OfferingFormData } from '../types'

const ns = 'Offerings.Details.form.offerAllQuantities'

export const OfferAllQuantitiesButton = ({
  setValues,
  values,
}: {
  setValues: (
    values: SetStateAction<OfferingFormData>,
    shouldValidate?: boolean
  ) => void
  values: OfferingFormData
}) => {
  const [refElem, setRefElem] = useState<HTMLButtonElement | null>(null)
  const { itemRows } = values

  const onClick = () => {
    setValues({
      ...values,
      itemRows: itemRows.map((o) => ({ ...o, offerQuantity: o.item.quantity })),
    })
    showSnackbar({
      content: <FormattedMessage id={`${ns}.success`} />,
      options: { autoClose: true, type: 'default' },
    })
  }

  return (
    <Button
      appearance="plainTertiary"
      onClick={onClick}
      ref={setRefElem}
      type="button"
    >
      <FormattedMessage id={`${ns}.cta`} />
      <Tooltip referenceElement={refElem}>
        <FormattedMessage id={`${ns}.tooltip`} />
      </Tooltip>
    </Button>
  )
}
